import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { EMPTY, Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { ServerErrorDialogService } from './domains/shared/services/server-error-dialog.service';
import { KeycloakService } from './domains/shared/services/keycloak.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  readonly router = inject(Router);
  readonly #serverErrorDialog = inject(ServerErrorDialogService);
  readonly #keycloak = inject(KeycloakService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if the request is to our API
    const isApiRequest = req.url.startsWith(environment.apiBaseUrl);

    if (!isApiRequest) {
      // If it's not an API request, just pass it through without error handling
      return next.handle(req);
    }

    // Only apply error handling for API requests
    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === 0) {
          this.router.navigate(['/server-error']);
          return EMPTY;
        }
        if (error.status >= 500 && error.status < 600) {
          this.#serverErrorDialog.show();
          return throwError(() => error);
        }
        if (error.status === 401) {
          this.#keycloak.login();
          return EMPTY;
        }
        if (error.status === 403) {
          this.router.navigate(['/access-denied']);
          return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}
